<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface Props {
  approvedParticipants: number;
  currentRound?: number;
  totalRounds?: number;
  isTournamentStarted: boolean;
}

const props = defineProps<Props>();
const { t } = useI18n();
</script>

<template>
  <!-- Tournament Info -->
  <div class="tournament-info">
    <div class="info-item">
      <span class="label">{{ t('tournament.info.participants_label') }}:</span>
      <span class="value">{{ approvedParticipants }}</span>
    </div>
    <div v-if="isTournamentStarted" class="info-item">
      <span class="label">{{ t('tournament.info.current_round_label') }}:</span>
      <span class="value">{{
        t('tournament.info.current_round_of', {
          current: props.currentRound ?? 0,
          total: props.totalRounds ?? 0,
        })
      }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tournament-info {
  display: flex;
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
  padding: var(--spacing-md);
  background: var(--gradient-secondary);
  border-radius: var(--border-radius-md);
  border: 1px solid var(--border-color);
}

.info-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.label {
  font-weight: 600;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

.value {
  color: var(--text-primary);
  font-weight: 500;
  font-size: var(--font-size-sm);
}

// Mobile responsive
@media (max-width: 768px) {
  .tournament-info {
    flex-direction: column;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm);
  }
}
</style>
